/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialV2FormData
 */
export interface ProviderCredentialV2FormData {
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormData
     */
    enabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof ProviderCredentialV2FormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof ProviderCredentialV2FormData
     */
    channel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof ProviderCredentialV2FormData
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof ProviderCredentialV2FormData
     */
    provider?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    secretName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    targetBranch?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    agencyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    agentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    agentPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    agentSecretName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    pcc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    subscriptionKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    subscriptionKeySecretName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    target?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    b2BAPIUserPasswordSecretName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    b2BAPIUserPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    b2BAPIUserEmailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    serviceUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    clientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    clientSecret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    authenticationUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    accessGroup?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    shoppingUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    shoppingClientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    shoppingClientSecret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    shoppingServiceUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    postShoppingUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    postShoppingClientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    postShoppingClientSecret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2FormData
     */
    postShoppingServiceUrl?: string | null;
}

export function ProviderCredentialV2FormDataFromJSON(json: any): ProviderCredentialV2FormData {
    return ProviderCredentialV2FormDataFromJSONTyped(json, false);
}

export function ProviderCredentialV2FormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialV2FormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'channel': !exists(json, 'channel') ? undefined : Int32IdAndLabelFromJSON(json['channel']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'provider': !exists(json, 'provider') ? undefined : GuidIdAndLabelFromJSON(json['provider']),
        'username': !exists(json, 'username') ? undefined : json['username'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'secretName': !exists(json, 'secretName') ? undefined : json['secretName'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'targetBranch': !exists(json, 'targetBranch') ? undefined : json['targetBranch'],
        'agencyId': !exists(json, 'agencyId') ? undefined : json['agencyId'],
        'agentName': !exists(json, 'agentName') ? undefined : json['agentName'],
        'agentPassword': !exists(json, 'agentPassword') ? undefined : json['agentPassword'],
        'agentSecretName': !exists(json, 'agentSecretName') ? undefined : json['agentSecretName'],
        'pcc': !exists(json, 'pcc') ? undefined : json['pcc'],
        'subscriptionKey': !exists(json, 'subscriptionKey') ? undefined : json['subscriptionKey'],
        'subscriptionKeySecretName': !exists(json, 'subscriptionKeySecretName') ? undefined : json['subscriptionKeySecretName'],
        'target': !exists(json, 'target') ? undefined : json['target'],
        'b2BAPIUserPasswordSecretName': !exists(json, 'b2BAPIUserPasswordSecretName') ? undefined : json['b2BAPIUserPasswordSecretName'],
        'b2BAPIUserPassword': !exists(json, 'b2BAPIUserPassword') ? undefined : json['b2BAPIUserPassword'],
        'b2BAPIUserEmailAddress': !exists(json, 'b2BAPIUserEmailAddress') ? undefined : json['b2BAPIUserEmailAddress'],
        'serviceUrl': !exists(json, 'serviceUrl') ? undefined : json['serviceUrl'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'clientSecret': !exists(json, 'clientSecret') ? undefined : json['clientSecret'],
        'authenticationUrl': !exists(json, 'authenticationUrl') ? undefined : json['authenticationUrl'],
        'accessGroup': !exists(json, 'accessGroup') ? undefined : json['accessGroup'],
        'shoppingUrl': !exists(json, 'shoppingUrl') ? undefined : json['shoppingUrl'],
        'shoppingClientId': !exists(json, 'shoppingClientId') ? undefined : json['shoppingClientId'],
        'shoppingClientSecret': !exists(json, 'shoppingClientSecret') ? undefined : json['shoppingClientSecret'],
        'shoppingServiceUrl': !exists(json, 'shoppingServiceUrl') ? undefined : json['shoppingServiceUrl'],
        'postShoppingUrl': !exists(json, 'postShoppingUrl') ? undefined : json['postShoppingUrl'],
        'postShoppingClientId': !exists(json, 'postShoppingClientId') ? undefined : json['postShoppingClientId'],
        'postShoppingClientSecret': !exists(json, 'postShoppingClientSecret') ? undefined : json['postShoppingClientSecret'],
        'postShoppingServiceUrl': !exists(json, 'postShoppingServiceUrl') ? undefined : json['postShoppingServiceUrl'],
    };
}

export function ProviderCredentialV2FormDataToJSON(value?: ProviderCredentialV2FormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'enabled': value.enabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'channel': Int32IdAndLabelToJSON(value.channel),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'provider': GuidIdAndLabelToJSON(value.provider),
        'username': value.username,
        'password': value.password,
        'secretName': value.secretName,
        'url': value.url,
        'targetBranch': value.targetBranch,
        'agencyId': value.agencyId,
        'agentName': value.agentName,
        'agentPassword': value.agentPassword,
        'agentSecretName': value.agentSecretName,
        'pcc': value.pcc,
        'subscriptionKey': value.subscriptionKey,
        'subscriptionKeySecretName': value.subscriptionKeySecretName,
        'target': value.target,
        'b2BAPIUserPasswordSecretName': value.b2BAPIUserPasswordSecretName,
        'b2BAPIUserPassword': value.b2BAPIUserPassword,
        'b2BAPIUserEmailAddress': value.b2BAPIUserEmailAddress,
        'serviceUrl': value.serviceUrl,
        'clientId': value.clientId,
        'clientSecret': value.clientSecret,
        'authenticationUrl': value.authenticationUrl,
        'accessGroup': value.accessGroup,
        'shoppingUrl': value.shoppingUrl,
        'shoppingClientId': value.shoppingClientId,
        'shoppingClientSecret': value.shoppingClientSecret,
        'shoppingServiceUrl': value.shoppingServiceUrl,
        'postShoppingUrl': value.postShoppingUrl,
        'postShoppingClientId': value.postShoppingClientId,
        'postShoppingClientSecret': value.postShoppingClientSecret,
        'postShoppingServiceUrl': value.postShoppingServiceUrl,
    };
}


